defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/CreateClub',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Params',
    'DanskeSpil/Domain/Authentification/Scripts/LoginController',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Models/PlayTogetherClub',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/CreateClub/Flow'
  ],
  function (Component, Params, LoginController, PlayTogetherDictionary, Utils, PlayTogetherClubModel, Flow) {

    // Component:
    Component('create-club', [PlayTogetherDictionary], function (m, route, settings, property) {

      // Components:
      var root = {
        controller: function () {
          this.rootDictionary = PlayTogetherDictionary;
          this.dictionary = this.rootDictionary.get.bind({ prefix: 'CreateClub/' });
          this.settings = settings;
          this.property = property;

          this.clubModel = m.prop(null);
          this.clubInstanceId = m.prop(Params.extract('clubInstanceId'));
          if (!this.clubInstanceId() ||
          !PlayTogetherClubModel.get(this.clubInstanceId())) {
            this.clubModel(PlayTogetherClubModel.new());
            Params.set('clubInstanceId=' + this.clubModel().id());
          } else {
            this.clubModel(PlayTogetherClubModel.get(this.clubInstanceId()));
          }

          this.clubModelFields = m.prop(this.clubModel().fields);

          LoginController.getLoginStatus(function (isLoggedIn) {
            if (!isLoggedIn) {
              var homeUrl = location.pathname.split('/', 2).join('/'); // would be: /spil-sammen
              LoginController.openLogin({
                cancelUrl: homeUrl
              });
            }
          });

          // Add event listener for redireting on user logout
          Utils.redirectOnLogout(settings.redirectOnLogout);
          Utils.checkLoginStatus();
        },

        view: function (controller) {
          return m.component(Flow, { controller: controller });
        }
      };

      // Routes:
      route('/', root);
    });

  });
